export function parseNameForSearch(name: string) {
    return name.replace(/[.()]/g, '').split(' ').filter(Boolean).join(' ');
}
